import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { NgTemplateOutlet } from '@angular/common';

import { BasicContentVariantInheritableComponent } from '../basic-content-variant.inheritable.component';
import { ComposableCardComponent } from '../../../composables/card/card.component';
import { BasicContentPartialTopBetweenComponent } from '../../partials/basic-content-partial-top-between/basic-content-partial-top-between.component';

@Component({
  selector: 'wl-basic-content-variant-placeholder',
  templateUrl: './basic-content-variant-placeholder.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    ComposableCardComponent,
    JssModule,
    NgTemplateOutlet,
    BasicContentPartialTopBetweenComponent,
  ],
})
export class BasicContentVariantPlaceholderComponent extends BasicContentVariantInheritableComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
}
